import { useEffect, useMemo, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import * as API from "../services/API";
import HeaderHome from "../headers/headerHome";
import Footer from "../components/Footer";
import "../css/ResetPassword.css";

const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export default function ResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const token = useMemo(
    () => new URLSearchParams(location.search).get("token"),
    [location.search]
  );

  const [validToken, setValidToken] = useState(false);
  const [checkingToken, setCheckingToken] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Lien invalide ou expiré.");
      setCheckingToken(false);
      return;
    }

    API.getTokenRequest(
      token,
      () => {
        setValidToken(true);
        setCheckingToken(false);
      },
      () => {
        setError("Lien invalide ou expiré.");
        setCheckingToken(false);
      }
    );
  }, [token]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (!token || !validToken) {
      setError("Lien invalide ou expiré.");
      return;
    }

    if (!PASSWORD_PATTERN.test(password)) {
      setError(
        "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre."
      );
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    API.getTokenResetRequest(
      { token, password },
      () => {
        setSuccess(true);
        setLoading(false);
        setTimeout(() => history.push("/login"), 3000);
      },
      (message) => {
        setError(message);
        setLoading(false);
      }
    );
  };

  if (success) {
    return (
      <>
        <HeaderHome />
        <div className="reset-container">
          <div className="reset-card success">
            <h2>Mot de passe modifié</h2>
            <p>Vous pouvez maintenant vous connecter.</p>
            <Link className="reset-back-link" to="/login">
              Aller à la connexion
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <HeaderHome />
      <div className="reset-container">
        <div className="reset-card">
          <h2>Réinitialiser le mot de passe</h2>

          {checkingToken ? (
            <p className="reset-description">Vérification du lien...</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="new-password">Nouveau mot de passe</label>
                <input
                  id="new-password"
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  disabled={!validToken || loading}
                  autoComplete="new-password"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirm-password">Confirmer le mot de passe</label>
                <input
                  id="confirm-password"
                  type="password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  disabled={!validToken || loading}
                  autoComplete="new-password"
                  required
                />
              </div>

              {validToken && (
                <p className="password-help">
                  8 caractères minimum, avec une majuscule, une minuscule et un chiffre.
                </p>
              )}

              {error && <div className="error-message">{error}</div>}

              {validToken && (
                <button type="submit" disabled={loading} className="reset-button">
                  {loading ? "Modification en cours..." : "Changer le mot de passe"}
                </button>
              )}
            </form>
          )}

          {!validToken && !checkingToken && (
            <Link className="reset-back-link" to="/forgot-password">
              Demander un nouveau lien
            </Link>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
